// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'


// Import Views - Top level
import AppView from './components/App.vue'


Vue.use(VueRouter)

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Check local storage to handle refreshes
/*if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}*/

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  render: h => h(AppView)
})


// WEBPACK FOOTER //
// ./src/main.js